// extracted by mini-css-extract-plugin
export default {"main_container":"TextInput_main_container__igIw3"};